import React from 'react';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import { Hidden, makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import DepartmentBadge from 'views/Users/Details/UserDetails/dialogs/subcomponents/DepartmentBadge';
import DatePicker from 'views/Users/Details/UserDetails/dialogs/subcomponents/DatePicker';
import { Caption } from 'components/Typography/Typography';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDepartmentBadgesProps {
	handleIsChecked: (deptId: string) => boolean;
	handleIsUnlimited: (deptId?: string) => boolean;
	handleGetDate: (deptId?: string) => string;
	handleSetDate: (deptId: string, value?: any) => void;
	handleBadgeClick: (deptId: string, name: string, uiColor: string) => void;
	showIsValid: boolean;
	isDepartmentValid: (deptId: string) => boolean;
	departments: SingleDepartment[];
}

const DepartmentBadges = ({
	handleIsChecked,
	handleIsUnlimited,
	handleGetDate,
	handleSetDate,
	showIsValid,
	isDepartmentValid,
	handleBadgeClick,
	departments,
}: IDepartmentBadgesProps) => {
	const classes = useStyles();

	const badgeHeader = (
		<div className={classes.permissionCellHeader}>
			<div className={classes.permissionCell}>
				<Caption color="secondary-light">{translate('department')}</Caption>
			</div>
			<div className={classes.permissionCell}>
				<Caption color="secondary-light">{translate('access.expiration.date')}</Caption>
			</div>
		</div>
	);

	return (
		<div>
			<Hidden smDown>{badgeHeader}</Hidden>
			<div>
				{(departments || []).map((department) => (
					<div key={department.deptId}>
						<Hidden smUp>{badgeHeader}</Hidden>
						<div className={classes.permissionContainer}>
							<div className={classNames(classes.permissionCell, classes.departmentBadgeContainer)}>
								<DepartmentBadge
									checked={handleIsChecked(department.deptId)}
									name={department.name}
									hexColor={department.uiColor}
									onClick={() =>
										handleBadgeClick(department.deptId, department.name, department.uiColor)
									}
								/>
							</div>
							<div
								className={classNames(classes.permissionCell, {
									[classes.calendarValue]: !!handleGetDate(department.deptId),
								})}
							>
								<DatePicker
									disabled={!handleIsChecked(department.deptId)}
									isUnlimited={handleIsUnlimited(department.deptId)}
									date={handleGetDate(department.deptId)}
									setDate={(value) => handleSetDate(department.deptId, value)}
									isCalendarRight
									errorText={translate('required.field')}
									error={
										showIsValid &&
										handleIsChecked(department.deptId) &&
										!isDepartmentValid(department.deptId)
									}
								/>
							</div>
						</div>
						<div>
							<div className={classes.departmentPermissionDivider} />
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default DepartmentBadges;
